import { makeActionCreator } from 'crazyEditor/redux/helpers';

export const UPDATE_ELEMENT_POSITION = 'crazyEditor/element/UPDATE_ELEMENT_POSITION';
export const UPDATE_ELEMENT_POSITION_BY_DELTA = 'crazyEditor/element/UPDATE_ELEMENT_POSITION_BY_DELTA';
export const DRAG_COMPLETE_AND_UPDATE_ELEMENTS_POSITION = 'crazyEditor/element/DRAG_COMPLETE_AND_UPDATE_ELEMENTS_POSITION';
export const DRAG_COMPLETE_AND_UPDATE_ELEMENTS_SIZE = 'crazyEditor/element/DRAG_COMPLETE_AND_UPDATE_ELEMENTS_SIZE';
export const UPDATE_ELEMENT_SIZE_BY_DIRECTION = 'crazyEditor/element/UPDATE_ELEMENT_SIZE_BY_DIRECTION';
export const UPDATE_ELEMENT_SIZE = 'crazyEditor/element/UPDATE_ELEMENT_SIZE';
export const UPDATE_MEASURED_HEIGHTS = 'crazyEditor/element/UPDATE_MEASURED_HEIGHTS';

// algin operations
export const ALIGN_SELECTED_ELEMENTS = 'crazyEditor/element/ALIGN_SELECTED_ELEMENTS';
export const ALIGN_DIRECTION = {
  PAGE_LEFT: 0,
  PAGE_CENTER: 1,
  PAGE_RIGHT: 2,
  LEFT: 3,
  CENTER_HORIZONTAL: 4,
  RIGHT: 5,
  TOP: 6,
  CENTER_VERTICAL: 7,
  BOTTOM: 8,
};


export const updateElementPosition = makeActionCreator(UPDATE_ELEMENT_POSITION, 'viewMode', 'ids', 'x', 'y');
export const updateElementPositionByDelta = makeActionCreator(UPDATE_ELEMENT_POSITION_BY_DELTA, 'viewMode', 'ids', 'deltaX', 'deltaY');
export const updateElementSize = makeActionCreator(UPDATE_ELEMENT_SIZE, 'viewMode', 'ids', 'width', 'height');
export const updateElementSizeByDirection = makeActionCreator(UPDATE_ELEMENT_SIZE_BY_DIRECTION, 'viewMode', 'ids', 'deltaX', 'deltaY', 'direction', 'keepAspectRatio');
export const updateMeasuredSizes = makeActionCreator(UPDATE_MEASURED_HEIGHTS, 'measuredSizes');
export const alignSelectedElements = makeActionCreator(ALIGN_SELECTED_ELEMENTS, 'viewMode', 'ids', 'direction');
export const dragCompleteAndUpdateElementsPosition = makeActionCreator(DRAG_COMPLETE_AND_UPDATE_ELEMENTS_POSITION, 'viewMode', 'ids', 'deltaX', 'deltaY');
export const dragCompleteAndUpdateElementsSize = makeActionCreator(DRAG_COMPLETE_AND_UPDATE_ELEMENTS_SIZE, 'viewMode', 'ids', 'deltaX', 'deltaY', 'direction', 'keepAspectRatio');
